import * as React from 'react';
import { FC } from 'react';
import type { Advert } from './useAdverts';

const Image: FC<{ src: string; alt: string }> = ({ src, alt }) => (
  <div className="advert--image">
    <img src={src} alt={alt} />
  </div>
);

const AdvertComponent: FC<{ advert: Advert; close: () => void; accept: () => void }> = ({ advert, close, accept }) => (
  <div className="advert">
    <a className="close-advert" onClick={close} aria-label="close">
      ×
    </a>
    <div className="row advert--container">
      {advert.image_url && <Image src={advert.image_url} alt={advert.title || ''} />}
      <div className="advert--content">
        {advert.title && <div className="advert--title">{advert.title}</div>}
        <div className="advert--body">{advert.body}</div>
      </div>
      <div className="advert--buttons">
        <a
          className="advert--accept button right radius bg-ginger small"
          onClick={accept}
          href={advert.action_url || undefined}
        >
          {advert.action_text}
        </a>
        {advert.tip && <span className="advert--tip">{advert.tip}</span>}
      </div>
    </div>
  </div>
);

export default AdvertComponent;
